const RELAY_RESPONSES = {
  DUPLICATE_REQUEST: 'Your request cannot be completed at this time',
};

const ERROR_STRINGS = {
  SIGN_IN_FAILURE: `We didn’t recognize the phone number or password you entered. Please try again.`,
  DUPLICATE_REQUEST:
    'An interpreter has already been requested. Please wait a moment for the interpreter to join.',
  UNABLE_TO_REQUEST:
    'We were unable to request an interpreter right now, please try again later.',
};

export { RELAY_RESPONSES, ERROR_STRINGS };
